import {
	Breadcrumbs,
	Grid,
	Link,
	type Theme,
	Typography,
	makeStyles,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

interface IBreadcrumb {
	label?: string;
	link?: string;
}

interface IProps {
	title?: string;
	breadcrumbs: IBreadcrumb[];
}

// @ts-ignore
const useStyles = makeStyles((theme: Theme) => ({
	breadcrumb: {
		fontSize: 14,
		fontWeight: theme.typography.fontWeightMedium,
	},
	title: {
		fontFamily: 'Inter',
		fontSize: 22,
		fontWeight: theme.typography.fontWeightMedium,
	},
}));

export function Title({ breadcrumbs, title }: IProps) {
	const classes = useStyles();

	return (
		<Grid container>
			<Grid item xs={12}>
				<Breadcrumbs
					aria-label={'breadcrumb'}
					separator={<NavigateNextIcon fontSize={'small'} />}
				>
					{breadcrumbs.map((breadcrumb: IBreadcrumb, index: number) =>
						index === breadcrumbs.length - 1 ? (
							<Typography
								className={classes.breadcrumb}
								color={
									breadcrumbs.length > 1
										? 'textPrimary'
										: 'secondary'
								}
								key={index}
								noWrap
							>
								{breadcrumb?.label || ''}
							</Typography>
						) : (
							<Link
								className={classes.breadcrumb}
								color={'secondary'}
								component={RouterLink}
								key={index}
								to={breadcrumb.link ? breadcrumb.link : ''}
							>
								{breadcrumb?.label || ''}
							</Link>
						),
					)}
				</Breadcrumbs>
			</Grid>

			<Grid item xs={12}>
				<Typography className={classes.title} noWrap>
					{' '}
					{title || ''}{' '}
				</Typography>
			</Grid>
		</Grid>
	);
}
